import type { AccruedInterests } from '@fortem-monorepo/web-sdk'

export type ChartDataRow = {
  id: string
  record_type: 'BALANCE' | 'COUPON' | 'BUY' | 'SELL'
  value_date: string
  accrued_balance_local: string | null
  trade_count: number | null
  trade_id: string | null
  trade_datetime_utc: string | null
  quantity: string | null
  currency: string | null
}

/** Flatten every chart series without rounding, filtering, or truncating to a grid page. */
export const getChartDataRows = (history: AccruedInterests.BalanceChart): ChartDataRow[] => {
  const blank = {
    accrued_balance_local: null,
    trade_count: null,
    trade_id: null,
    trade_datetime_utc: null,
    quantity: null,
    currency: history.instrument.currency,
  }

  const rows: ChartDataRow[] = [
    ...history.points.map((point) => ({
      ...blank,
      id: `balance:${point.value_date}`,
      record_type: 'BALANCE' as const,
      value_date: point.value_date,
      accrued_balance_local: point.accrued_balance_local,
      trade_count: point.trade_count,
    })),
    ...history.coupon_dates.map((date) => ({
      ...blank,
      id: `coupon:${date}`,
      record_type: 'COUPON' as const,
      value_date: date,
    })),
    ...history.trades.map((trade) => ({
      ...blank,
      id: `trade:${trade.trade_id}`,
      record_type: trade.side,
      value_date: trade.trade_datetime_utc.slice(0, 10),
      trade_id: trade.trade_id,
      trade_datetime_utc: trade.trade_datetime_utc,
      quantity: trade.quantity,
    })),
  ]

  return rows.sort(
    (a, b) =>
      a.value_date.localeCompare(b.value_date) ||
      a.record_type.localeCompare(b.record_type) ||
      a.id.localeCompare(b.id),
  )
}
